import { graphql, useStaticQuery } from "gatsby";
import { useMemo } from "react";
import usePageLang from "../usePageLang";
import type { CrossSellingProduct } from "@src/components/page-content/Cart/CartCrossSellingStep/CrossSellingProductCard.interface";

export type ProductItem = Queries.productFieldsFragment;

export type UseAllProductNode = Queries.productFieldsFragment;

export const useAllProduct = (): {
  data: ProductItem[];
} => {
  const currentLang = usePageLang();
  // static query
  const { allProduct } = useStaticQuery<Queries.AllProductQuery>(graphql`
    query AllProduct {
      allProduct {
        nodes {
          ...productFields
        }
      }
    }
  `);

  const data: ProductItem[] = useMemo(() => {
    if (!allProduct) return [];
    return allProduct.nodes.filter(
      ({ lang }) => lang === currentLang
    ) as ProductItem[];
  }, [allProduct, currentLang]);

  return { data };
};

export const getProduct = (
  data: ProductItem[],
  id_product?: string | number | null
) => {
  return data.find((product) => product.id_product === id_product) as
    | ProductItem
    | undefined;
};

interface GetProductListCategory
  extends Pick<Queries.categoryFieldsFragment, "products"> {}

export const getProductList = (
  data: ProductItem[],
  category: GetProductListCategory
): CrossSellingProduct[] =>
  (category.products || [])
    .map((id_product) => getProduct(data, id_product))
    .filter((product): product is CrossSellingProduct => product !== undefined);
